<template>
  <div class="row p-3">
    <div class="col-12 mb-4 ps-0">
      <h5 class="card-title">In welche Kategorie würden Sie Ihre Veranstaltung am ehesten einordnen?</h5>
    </div>
    <ErrorMessage name="veranstaltung_kategorie" class="font-bold my-2"/>
    <Field type="radio" name="veranstaltung_kategorie" v-model="surveyStore.data.veranstaltung.kategorie">
      <div class="form-check col-12 col-lg-6" :key="radio.key" v-for="radio in radios">
        <input type="radio" v-model="surveyStore.data.veranstaltung.kategorie" :value="radio.key" :id="radio.key"
               class="form-check-input" :class="{'is-invalid': errors.veranstaltung_kategorie}"/>
        <label class="form-check-label" :for="radio.key">
          {{ radio.label }}
        </label>
      </div>
    </Field>
  </div>
</template>

<script>
import {useSurveyStore} from "../../../stores/survey";
import {Field, ErrorMessage} from 'vee-validate';

export default {
  components: {
    Field,
    ErrorMessage
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {
      radios: [
        {
          key: 'aktiv-natur-tour',
          label: 'Aktiv / Natur / Touren'
        },
        {
          key: 'feste-festivals-maerkte',
          label: 'Fest / Festival / Markt'
        },
        {
          key: 'kinder-veranstaltung',
          label: 'Event speziell für Kinder'
        },
        {
          key: 'kino-filmvorfuehrung',
          label: 'Kino - nur kulturell (Kulturkino, Freiluftkino, ...)'
        },
        {
          key: 'konzert-jazz',
          label: 'Konzert - Jazzmusik, Swing'
        },
        {
          key: 'konzert-rock-pop-elektro',
          label: 'Konzert - Rock, Pop, Elektro'
        },
        {
          key: 'konzert-sonstige-musik',
          label: 'Konzert - sonstige Musik'
        },
        {
          key: 'kulinarik-kulinarisch-verkostung',
          label: 'Kulinarik'
        },
        {
          key: 'kunst-ausstellung',
          label: 'Kunst/Austellungen'
        },
        {
          key: 'lesung-vortrag',
          label: 'Lesungen & Vorträge'
        },
        {
          key: 'messe-kongress',
          label: 'Messen & Kongresse'
        },
        {
          key: 'open-air-erlebnisshow',
          label: 'Open-Airs / Erlebnisshows'
        },
        {
          key: 'seminar-kurs-workshop',
          label: 'Seminare, Kurse & Workshops'
        },
        {
          key: 'sportveranstaltungen',
          label: 'Sportveranstaltungen'
        },
        {
          key: 'tanz-party-disco',
          label: 'Tanz / Party / Disco'
        },
        {
          key: 'theater-buehne-comedy-musical',
          label: 'Theater, Musicals, Bühne & Comedy'
        },
        {
          key: 'feste',
          label: 'kleines Fest / Grillfest / traditionelles Feuer (Tourismus geeignet)'
        },
      ]
    }
  },
  props: {
    errors: Object,
  },
  methods: {},
  computed: {},

}
</script>
